<template>
  <div class="linkbucket">
    <div class="lbleft">
      <a
        href="#"
        @click.prevent="toggleFootnotes">{{ showHideFootnotesLabel }}</a>
    </div>
    <div class="lbright">
      <a
        :href="dataGuideUrl"
        @click="dataGuideClicked"
      >Data Guide</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import helper from '../../helper';

export default {
  computed: {
    ...mapState({
      footnotes: state => state.footnotes,
      showFootnotes: state => state.LP.flags.showFootnotes,
    }),
    showHideFootnotesLabel() {
      return this.showFootnotes ? 'Hide footnotes' : 'Show footnotes';
    },
    dataGuideUrl() {
      const row = _(this.footnotes).find({ type: 'RelatedLinks', ft: 'Data Guide' });
      return row ? helper.convertRelativeUrlToWCMSUrl(row.url) : '';
    },
  },
  methods: {
    toggleFootnotes() {
      this.$store.commit('LP/setShowFootnotes', !this.showFootnotes);
      this.$store.getters['LP/setBrowserUrlBarToReflectCurrentLPState'](this.$router);
      this.$store.commit('LP/setInteractionTypeIfEmpty', `IB ${this.showFootnotes ? 'SF' : 'HF'}`);
    },
    dataGuideClicked() {
      this.$store.commit('LP/setInteractionTypeIfEmpty', 'IB DG');
    },
  },
};
</script>


<style scoped>
  .linkbucket {
    display: table;
    background-color: rgb(242, 242, 242);
    /* margin: 8px; */
    padding: 8px;
    min-width: 280px;
  }

  .linkbucket a {
    display: block;
  }

  .lbleft {
    display: table-cell;
    width: 50%;
  }

  .lbright {
    display: table-cell;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LP/LinkBucket.vue